export default __webpack_public_path__ + "static/media/teddy.a36a7b95.ogg";